<template>
    <v-container class="main-container responsive-height mt5-details-wrapper">
        <v-row dense>
            <v-col cols="12" md="7">
                <TitleCard></TitleCard>
                <v-row dense>
                    <v-col
                        cols="12"
                        sm="4"
                        v-for="item in forecast"
                        :key="item.day"
                    >
                        <v-card
                            outlined
                            tile
                            :to="item.links"
                            :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'"
                            class="widgets-card"
                        >
                            <v-btn
                                class="mx-2 mb-3"
                                fab
                                link
                                small
                                elevation="0"
                                :color="
                                    $vuetify.theme.dark ? '#1A2A3E ' : '#F8F6FC'
                                "
                            >
                                <v-icon color="greenMain">
                                    {{ item.icon }}
                                </v-icon>
                            </v-btn>
                            <p class="mb-0">{{ item.day }}</p>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="5">
                <BalanceCard></BalanceCard>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12">
                <v-card
                    flat
                    class="profile-card rounded-0"
                    :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'"
                >
                    <div class="user-profile">
                        <div class="profile-image">
                            <v-badge
                                avatar
                                bordered
                                overlap
                                color="black accent-4"
                                icon="mdi-star-outline"
                            >
                                <v-avatar size="59">
                                    <v-img
                                        src="../../assets/avatar.png"
                                    ></v-img>
                                </v-avatar>
                            </v-badge>
                        </div>
        
                        <div class="profile-text">
                            <span>My Manager ({{investormanageraccount?.profit_sharing ||0}}%)</span>
                            <span>{{investormanageraccount?.st_username ||'N/A'}}</span>
                        </div>
                    </div>

                    <div class="user-profile-btn">
                        <v-btn
                            tile
                            elevation="0"
                            :to="`/manager-details?id=${investormanageraccount?.manager_id}&type=${investormanageraccount?.manager_type}`"
                            class="ma-0 text-capitalize btn-account"
                            color="greenMain"
                        >
                            View Manager Profile
                        </v-btn>
                    </div>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <MiddleBar></MiddleBar>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="12" class="position-relative">
                <Mt5DetailsAllTabs></Mt5DetailsAllTabs>
                <v-card class="profit-loss rounded-0" flat color="transparent">
                    <ul>
                        <li>
                            <span class="text-warning">Total Lot:</span>
                            <span>{{
                                investorAccountSummary.totalLot.toFixed(2)
                            }}</span>
                        </li>
                        <li>
                            <span class="profit-losses">Profit / Loss:</span>
                            <span>{{
                                investorAccountSummary.profitLoss.toFixed(2)
                            }}</span>
                        </li>
                    </ul>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { TRADING__ACTIONS, MAM__ACTIONS } from "@/store/action-types";

import BalanceCard from "@/components/PagesComponents/MyInvestorAccountDetailsPage/BalanceCard.vue";
import MiddleBar from "@/components/PagesComponents/MyInvestorAccountDetailsPage/MiddleBar.vue";
import Mt5DetailsAllTabs from "@/components/PagesComponents/MyInvestorAccountDetailsPage/Mt5DetailsAllTabs.vue";
import TitleCard from "@/components/PagesComponents/MyInvestorAccountDetailsPage/TitleCard.vue";

export default {
    data: () => ({
        forecast: [
            { day: "Deposit", icon: "mdi-tray-arrow-down", links: "/deposit" },
            {
                day: "Transfer",
                icon: "mdi-swap-horizontal",
                links: "/internal-transfer",
            },
            {
                day: "Change Password",
                icon: "mdi-lock-open-outline",
                links: "/change-mt5-password",
            },
        ],
    }),
    components: {
        BalanceCard,
        TitleCard,
        MiddleBar,
        Mt5DetailsAllTabs,
    },

    computed: {
        ...mapState("trading", ["investorAccountSummary"]),
        ...mapState("mam", ["investormanageraccount"]),
    },

    methods: {
        ...mapActions("trading", [TRADING__ACTIONS.INVESTORACCOUNTLIVETRADES]),
        ...mapActions("mam", [MAM__ACTIONS.INVESTORMANAGERACCOUNT]),
    },

    async mounted() {
        await this[TRADING__ACTIONS.INVESTORACCOUNTLIVETRADES](
            this.$route.query.id
        );

        await this[MAM__ACTIONS.INVESTORMANAGERACCOUNT](
            this.$route.query.id
        );
    },
};
</script>
